import { useEffect, useRef, useState } from 'react';

export const RestaurantCallSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.3,
        rootMargin: '0px 0px -100px 0px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section 
      ref={sectionRef}
      className="py-14 sm:py-20 bg-gradient-to-br from-purple-50 to-pink-50"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className={`text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-gray-800 mb-4 sm:mb-6 transition-all duration-1000 ${
            isVisible 
              ? 'opacity-100 translate-y-0' 
              : 'opacity-0 translate-y-8'
          }`}>
            Solution spéciale 
            <span className={`bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent transition-all duration-1000 delay-300 ${
              isVisible 
                ? 'opacity-100 scale-100' 
                : 'opacity-0 scale-95'
            }`}> restaurateurs</span>
          </h2>
          <p className={`text-base sm:text-xl md:text-2xl text-purple-700 font-accent font-bold mb-6 sm:mb-8 px-4 transition-all duration-1000 delay-500 ${
            isVisible 
              ? 'opacity-100 translate-y-0' 
              : 'opacity-0 translate-y-8'
          }`}>
            À vos fourneaux, prêts, vendez !
          </p>
          <div className={`flex justify-center transition-all duration-1000 delay-700 ${
            isVisible 
              ? 'opacity-100 translate-y-0' 
              : 'opacity-0 translate-y-8'
          }`}>
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-arrow-down-line text-3xl text-purple-600 animate-bounce"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
